import(/* webpackMode: "eager" */ "/vercel/path0/app/reservation/page.tsx");
